import {
    CUSTOM_ROLE,
    DEFAULT_ROLES,
    RELATIONS,
    USER_RELATIONS
} from '../../app/root/constants'

const nl = {
    dashboard: {
        dashboard: 'Dashboard',
        mapView: 'MapView',
        switcherHoverTooltip: 'Stel en sla uw standaardweergave op',
        defaultViewUpdateFail: 'Standaard dashboardweergave bijwerken mislukt',
        reports: 'Berichten van de laatste 30 dagen',
        addressUpdateSuccess: 'Locatieadres succesvol bijgewerkt',
        addressUpdateFail: 'Het bijwerken van het locatieadres is mislukt',
        deviceStatusTooltipText: {
            inactive: 'De apparaten zijn nu inactief.',
            critical: 'De uitrusting moet persoonlijk worden gecontroleerd.',
            info: 'De apparaten functioneren naar behoren.',
            warning:
                'De WiFi-verbinding kan onstabiel zijn of de batterij is bijna leeg'
        },
        loggedInAs: 'Ingelogd als: '
    },
    customers: {
        customer: 'Klant',
        customers: 'Klanten',
        plan: 'Software plan',
        noCustomers: 'Geen klanten gevonden',
        noCustomer: 'Klant werd niet gevonden',
        hotswapPortal: 'HotSwap Portaal',
        hotswapPortalAccess: 'Toegang verlenen tot het Hot Swap-proces',
        hotswapUpdateService: 'Update Service',
        hotswapUpdateServiceAccess: 'Staat de optie voor updateservice toe',
        hotswapWelcomeEmail: 'HotSwap Welkomstemail',
        customerUsersTable: 'Tabel met klantgebruikers',
        errorGettingUsersListForCustomer:
            'Fout bij het ophalen van gebruikerslijst'
    },
    hotSwap: {
        capacityIssueMessage:
            'Beste klanten, vanwege de huidige hoge werkdruk door vakanties en JERRY3-opdrachten worden Hotswap-boekingen elke donderdag om 15:00 uur vrijgegeven. Als Hotswap-boekingen momenteel niet mogelijk zijn, vragen we u om een beetje geduld. We actualiseren de capaciteiten elke week. Bij vragen kunt u rechtstreeks contact opnemen met m.weigert@traplinked.com.',
        hotSwap: 'HotSwap',
        hotSwapAdmin: 'HotSwap Beheerder',
        hotSwapOrders: 'HotSwap Bestellingen',
        startHotSwap: 'Start HotSwap',
        hotSwapVideoManual: 'HotSwap Videohandleiding',
        videoNotSupported: 'Uw browser ondersteunt de video tag niet.',
        hotSwapType: 'Hotswap Type',
        swapReplacment: 'Apparaat Vervanging',
        description:
            'Sommige van uw apparaten kunnen meer batterij verbruiken dan verwacht. Om dit op te lossen, hebben we een nieuwe firmware ontwikkeld en moeten de oude apparaten worden vervangen. Op deze pagina kunt u het hele proces beheren.',
        introVideo: 'Introductievideo',
        welcomeTitle: 'Welkom bij ons HotSwap-proces',
        welcomeDesc:
            'We zijn blij dat je aan boord bent. Hier zijn enkele snelle tips om je op weg te helpen.',
        summary: {
            changeLocation: 'Locatie wijzigen'
        },
        hotSwapTableEmptyListMessage:
            'Sorry, er zijn op dit moment geen hot swap-items om weer te geven. Kom later terug of neem contact op met de ondersteuning voor hulp.',
        swap_by_user: {
            label: 'Bestel vervangende apparaten',
            title: 'Vervang apparaten zelf',
            description:
                'Wij sturen u vervangende apparaten en u wisselt ze zelf om',
            features: {
                1: 'Bestel vervangende apparaten',
                2: 'Schakel nieuwe apparaten in & schakel oude apparaten uit',
                3: 'Flexibel wanneer u het nodig hebt'
            },
            stepper: {
                firstStepHeader: 'Verzendplanning',
                firstStepSubHeader: 'Wanneer moeten we de apparaten verzenden?',
                secondStepHeader: 'Verzendadres',
                secondStepSubHeader: 'Waar moeten we de apparaten bezorgen?',
                thirdStepHeader: 'Samenvatting',
                thirdStepSubHeader: 'Bevestig uw HotSwap-bestelling'
            },
            btnText: 'Apparaten bestellen',
            summary: {
                date: 'Bezorgdatum',
                address: 'Verzendadres'
            },
            successTitle: 'HotSwap succesvol gepland',
            successDesc:
                'Gefeliciteerd. We beginnen met het voorbereiden van uw apparaten en zullen ze op tijd naar u verzenden.',
            footerText: 'Tracking Number:',
            trackingLink: 'Volglink:',
            detailsPageText: 'Shipping',
            termsAndConditonsLinkPart: 'Ik ga akkoord met de HotSwap',
            termsAndConditonsLink: 'Algemene voorwaarden',
            termsAndConditonsTextHeader: 'HotSwap Voorwaarden',
            termsAndConditonsTextFirstParagraph:
                'In het kader van het HotSwap-proces stemt u in met de volgende voorwaarden:',
            termsAndConditonsTextSecondParagraph:
                "Voor het uitwisselen van magazijnapparaten, maak alstublieft een nieuwe locatie aan in de traplinked-app en noem deze ['Uw Bedrijfsnaam' + Hot Swap Magazijnverzending]. Verplaats alle LoRa-apparaten die zich momenteel in uw magazijn bevinden naar deze nieuw gecreëerde locatie om de soepele uitwisseling van apparaten te vergemakkelijken.",
            termsAndConditonsTextThirdParagraph:
                'Voor de uitwisseling van apparaten die zich op klantlocaties bevinden, vragen we u vriendelijk om de toewijzing in de traplinked-app te verifiëren. Als u geen (klant)locaties heeft aangemaakt of als u onze locatiefunctie niet gebruikt omdat u alleen via het traplinked-interface werkt, neem dan contact met ons op voordat u vervangende apparaten boekt via dit portaal.',
            termsAndConditonsTextFourthParagraph:
                'Als onderdeel van het HotSwap-proces stemt u ermee in om de uitgewisselde apparaten binnen 7 dagen na een succesvolle afronding van het HotSwap-proces aan ons terug te sturen (traplinked GmbH, Zollhof 7, 90443 Neurenberg). Wij dekken de verzendkosten en het retourlabel wordt meegeleverd met uw vervangende apparaten. Als er vertragingen optreden bij de retourzending als gevolg van uw acties, kunnen eventuele bijkomende kosten aan u worden doorberekend. We hebben de uitgewisselde apparaten nodig om de herziening van alle systemen zo snel mogelijk te versnellen.',
            termsAndConditonsTextFivethParagraph:
                'Wij staan tot uw beschikking om u te helpen en eventuele vragen te beantwoorden gedurende het HotSwap-proces. Dank u voor uw samenwerking en begrip.'
        },
        update_service: {
            label: 'Boek een datum',
            title: 'Update Service door traplinked',
            description: 'We updaten uw apparaten op de huidige locatie',
            features: {
                1: 'Boek een afspraak',
                2: 'Geüpdatet door een traplinked-technicus',
                3: 'Snel & comfortabel'
            },
            stepper: {
                firstStepHeader: 'Boek Update Service',
                firstStepSubHeader:
                    'Wanneer moet de traplinked-technicus komen?',
                secondStepHeader: 'Locatieadres',
                secondStepSubHeader: 'Waar is de locatie?',
                thirdStepHeader: 'Samenvatting',
                thirdStepSubHeader: 'Bevestig Update Service boeking'
            },
            btnText: 'Boek een afspraak',
            summary: {
                date: 'Datum & tijd',
                address: 'Locatieadres'
            },
            successTitle: 'Update Service succesvol geboekt',
            successDesc:
                'Gefeliciteerd. Onze technicus zal op de gedefinieerde locatie zijn op de gevraagde datum & tijd.',
            footerText: 'Technician:',
            detailsPageText: 'Update Service'
        },
        rememberAddress: 'Onthoud verzendadres',
        saveAddress: 'Bewaar dit adres voor de volgende wissel.',
        backToDashboard: 'Terug naar het dashboard',
        accordionDevicesTable: {
            exchangeDevice: 'Uitwisselingsapparaat',
            connectivity: 'Connectiviteit',
            hbInterval: 'HB-interval',
            trapSide: 'Valzijde',
            wifiData: 'WIFI-gegevens'
        },
        carrier: 'Vervoerder'
    },
    locations: {
        storageSectionTitle: 'Opslag',
        storageSectionNetworkDevicesTitle: 'Netwerk apparaten',
        storageSectionDevicesTitle: 'Apparaten',
        devicesListTitle: 'Apparaten',
        dragAndDropMsg: 'Drag n drop pin hier!',
        floorPlanLoadingError:
            'Fout bij het laden van de plattegrond. Probeer het opnieuw',
        locations: 'Locaties',
        noLocations: 'Geen locaties beschikbaar',
        searchUser: 'Zoek gebruiker',
        pleaseSelectLocation: 'Gelieve een locatie te kiezen',
        sureNotToSaveLocation:
            'Weet u zeker dat u de nieuwe locatie niet wilt opslaan?',
        addSubLocation: 'Voeg sub-locatie toe',
        addDevices: 'Apparaten toevoegen',
        removeLocation: 'Locatie verwijderen',
        devices: 'Apparaten',
        network: 'Netwerk',
        networkDevice: 'Netwerk Apparaat',
        overview: 'Overzicht',
        reports: 'Berichten',
        stats: 'Statistieken',
        shareInfo: 'Toegangsinformatie',
        floorPlan: 'Plattegrond',
        location: 'Locatie',
        pictures: 'Afbeeldingen',
        organisation: 'Bedrijf',
        version: 'Versie',
        status: 'Status',
        share: 'Deel',
        batteryStatus: 'Batterijniveau',
        actions: 'Acties',
        noDevicesAdded:
            'Er zijn geen nieuwe apparaten toegevoegd aan de locatie',
        devicesOnLocation: 'Apparaten op deze locatie',
        noDevicesSetupYet: 'Nog geen apparaten op deze locatie',
        nameCanNotBeEmpty: 'De naam mag niet leeg zijn.',
        address: 'Adres',
        parentLocation: 'Ouderlocatie',
        noParentLocation: 'Geen ouderlocatie',
        locationNotFound: 'Locatie niet gevonden',
        deviceName: 'Naam apparaat',
        deviceSerial: 'Serie van apparaat',
        event: 'Bericht',
        time: 'Tijd',
        reportsOnLocation: 'Berichten op locatie',
        noReportsOnLocation: 'Nog geen berichten op deze locatie',
        locationStatistics: 'Statistieken locatie',
        noLocationStatistics: 'Nog geen statistieken voor deze locatie',
        locationNotShared:
            'Deze locatie wordt niet gedeeld met een andere gebruiker',
        sureRevokeShareAccessLocation:
            'Weet u zeker dat u de toegang voor deze gebruiker wilt intrekken?',
        devicesAmount: 'Aantal apparaten',
        noDevicesToAddFound:
            'Er zijn geen apparaten gevonden om toe te voegen.',
        deleteLocationsModalText:
            'Weet u zeker dat u deze locatie wilt verwijderen? Alle sub-locaties worden ook verwijderd. Alle apparaten zullen worden verplaatst naar de Opslagruimte. Gaat u verder?',
        dragNDropInfo: `Sleep hier bestanden naartoe, of klik om bestanden te selecteren.`,
        dragNDropFiles: '(U kunt png-, jpeg- en pdf-bestanden uploaden)',
        deleteFloorPlanModal:
            'Weet u zeker dat u de plattegrond wilt verwijderen?',
        toDeleteFloorPlanTypeIn:
            'Voer dit nummer in om de plattegrond te verwijderen:',
        goToDevice: 'Weergave apparaat',
        removeFromFloorPlan: 'Verwijderen uit plattegrond',
        noFloorPlan: 'Er is geen plattegrond voor deze locatie',
        addFloorPlan: 'Upload plattegrond',
        addDevice: 'Apparaat toevoegen',
        addNewDevice: 'Nieuw apparaat toevoegen',
        devicesInThisLocation: 'Apparatuur op deze locatie',
        floorPlanBtns: {
            appearance: 'Uiterlijk',
            actions: 'Acties',
            add: 'Apparaten Toevoegen',
            allFilters: 'Filters',
            filter: 'Filter de apparaten',
            delete: 'Plattegrond verwijderen',
            replace: 'Plattegrond vervangen',
            serialLabel: 'Serienummers',
            nameLabel: 'Apparaatnaam'
        },
        locationsPath: 'Locatie pad',
        locationId: 'Locatie-ID',
        newLocation: '- Nieuwe locatie -',
        responsible: 'Verantwoordelijk',
        onlyResponsibleLocations: 'Toon mijn locaties',
        unlockMarkers: 'Marker losmaken',
        lockMarkers: 'Fix marker',
        responsibleTooltip:
            'De locaties waarvoor u verantwoordelijk bent, zijn gemarkeerd met een kleine blauwe stip',
        addResponsible: 'Verantwoordelijke persoon toevoegen',
        add: 'Toevoegen',
        scanWithQr: 'Scan',
        allLocations: 'Alle',
        myLocations: 'Mijn locaties',
        userSearchError: 'Zoekfout gebruiker',
        getResponsiblesError:
            'Fout bij het laden van de verantwoordelijke gebruikers voor deze locatie',
        addResponsibleError:
            'Fout bij het toevoegen van de verantwoordelijke persoon',
        deleteResponsibleError:
            'Fout bij het verwijderen van de verantwoordelijke gebruiker',
        getResponsibleLocationsError:
            'Fout bij het laden van locaties voor de verantwoordelijke gebruiker',
        userNotFound: 'Gebruiker niet gevonden...',
        noLocationsForResponsible:
            'Er zijn nog geen locaties aan u toegewezen.',
        assign: 'Toewijzen',
        contact: 'Contactpersoon',
        locationEmail: 'Locatie E-mail',
        locationDetails: 'Locatiegegevens (Optioneel)',
        contactPhone: 'Locatie Telefoon',
        noFloorplan: 'Er is nog geen plattegrond geüpload.',
        selectFile: 'Selecteer een bestand of zet het bestand hier neer',
        uploadFloorplan: 'Plattegrond uploaden',
        editFloorplan: 'Plattegrond bewerken',
        crop: 'Bijsnijden',
        rotate: 'Draaien',
        save: 'Opslaan',
        somethingWentWrong: 'Oops, Er is iets fout gegaan',
        heatmap: 'Heatmap',
        escalationLevels: 'Escalatieniveaus',
        level: 'Niveau',
        sendAutomaticallyTriggered: 'Automatisch E-Mails versturen',
        days: 'Dagen',
        hours: 'Uren',
        afterTrapStatus:
            'Nadat de val zijn status heeft ontvangen en de status niet heeft veranderd',
        afterTheTrapTriggered:
            'nadat de val geactiveerd werd en de status niet veranderde',
        eMailOfRecipient: 'E-mail van ontvanger',
        addLevel: 'Niveau toevoegen',
        escalationModalSubTitle:
            'Het bericht wordt samen met de apparaatinformatie en de plattegrondafbeelding aan de e-mail toegevoegd',
        locationsWithoutAddressLabel:
            'De volgende locaties hebben geen adres, sla het adres voor deze locaties op:',
        locationsWithoutAddressAndWithoutCoordsLabel:
            'De volgende locaties hebben een adres, maar kunnen niet worden weergegeven op de kaart omdat het adres niet is gevonden op de kaart',
        floorPlanPinCaution:
            'We raden aan het apparaat opnieuw op te starten als u het naar een nieuwe locatie hebt verplaatst',
        showCompletedTasks: 'Toon voltooide taken',
        hideCompletedTasks: 'Verberg voltooide taken',
        tasksAtThisLocation: 'Taken op deze locatie',
        createNewTask: 'Nieuwe taak maken',
        tasks: 'Taken',
        tasksFetchFail: 'Taken ophalen mislukt',
        taskCreated: 'Taak succesvol aangemaakt',
        taskCreateFail: 'Taak aanmaken mislukt',
        taskUpdated: 'Taak succesvol bijgewerkt',
        taskUpdateFail: 'Taak bijwerken mislukt',
        taskDescriptionTooLong:
            'Taakbeschrijving is te lang, maximaal 1024 tekens toegestaan',
        includeSubLocations: 'Sub locaties opnemen',
        last30Days: 'Laatste 30 dagen',
        last7Days: 'Laatste 7 dagen',
        clickOnThePFM: 'Klik op het punt voor meer informatie',
        reportsAmount: 'Aantal rapporten',
        settingsAndActions: 'Instellingen en acties',
        locationSettings: 'Locatie-instellingen',
        locationActions: 'Locatie-acties',
        baitSettings: 'Jerry Bait instellingen',
        successWithAmountOfUpdatedDevices:
            'Succes! Aantal bijgewerkte apparaten:',
        settingsAndActionsAreAppliedToAll:
            'Locatiegebaseerde instellingen en acties worden toegepast op alle apparaten op deze locatie.',
        settingsAndActionsAreNotAppliedToSL:
            'De instellingen en acties worden niet toegepast op sublocaties en apparaten in sublocaties.',
        noSettingsConfiguredYet:
            'Nog geen instellingen geconfigureerd voor deze locatie.',
        selectSettingType: 'Selecteer instellingstype',
        areYouSureYouWantToRemoveThisSetting:
            'Weet u zeker dat u deze instelling wilt verwijderen?',
        resetTheActivityThreshold: 'Activiteitsdrempel resetten',
        resetTheActivityThresholdDescr:
            'Het resetten van de activiteitsdrempel wist het aantal activiteiten voor de geselecteerde periode',
        locationBasedSettingsAndActions:
            'Locatiegebaseerde instellingen en acties',
        lBasedConfirmReplaceBaitQuestion:
            'Door dit te bevestigen, stelt u de datum van de laatste aasvervanging in voor alle apparaten op deze locatie.',
        lBasedConfirmThresholdResetQuestion:
            'Door dit te bevestigen, reset u de activiteiten voor alle apparaten op deze locatie. Een nieuwe drempel wordt ingesteld en activiteiten worden gereset voor de geselecteerde periode.',
        lBasedSettingsAreAppliedYouCanNotEdit:
            'De waarden voor lokaasgewicht en activiteit worden door de locatie bepaald. Open de locatie-instellingen om ze te wijzigen.',
        lBasedSettingsAreApplied:
            'De waarden voor lokaasgewicht en activiteit worden door de locatie bepaald.',
        confirmPowerOffDescr:
            "Hiermee bevestigt u dat u alle apparaten op deze locatie hebt uitgeschakeld. De apparaten krijgen de status 'Inactief'",
        switchMMModeOnDescr:
            'Schakelt onderhoudsmodus in voor alle apparaten op deze locatie. In onderhoudsmodus wijzigt het apparaat zijn status niet, worden er geen rapporten aangemaakt en worden er geen meldingen verzonden.',
        switchMMModeOffDescr:
            'Schakelt onderhoudsmodus uit voor alle apparaten op deze locatie.',
        confirmMMModeOnDescr:
            'Onderhoudsmodus wordt ingeschakeld voor alle apparaten op deze locatie. In onderhoudsmodus wijzigt het apparaat zijn status niet, worden er geen rapporten aangemaakt en worden er geen meldingen verzonden.',
        confirmMMModeOffDescr:
            'Onderhoudsmodus wordt uitgeschakeld voor alle apparaten op deze locatie.'
    },
    devices: {
        noDeviceMoveHistoryMsg: 'Geen bewegingsgeschiedenis voor dit apparaat.',
        getDeviceMoveHistoryEx:
            'Fout opgetreden bij het laden van het apparaat verplaatsingsgeschiedenis',
        assigned: 'Toegewezen',
        allDevices: 'Alle apparaten',
        details: 'Details',
        devices: 'Apparaten',
        location: 'Locatie',
        organisation: 'Bedrijf',
        version: 'Versie',
        serialNr: 'Serienummer',
        name: 'Naam',
        deviceSerial: 'Apparaat serienummer',
        description: 'Omschrijving',
        operationModeLabel: 'Bedrijfsmodus',
        heartbeatCount: 'Aantal statusberichten',
        mode: 'Modus',
        status: 'Status',
        batteryStatus: 'Batterijniveau',
        actions: 'Acties',
        noDevicesSetup: 'Nog geen apparaten ingesteld',
        noUserFromAnotherOrg: 'Er is nog geen gebruiker van een ander bedrijf.',
        pleseAddUserFromAnotherOrg:
            'Gelieve een gebruiker van een ander bedrijf toe te voegen.',
        inUserMgmt: 'in Gebruikersbeheer',
        chooseUserToShareWith: 'Kies aub een gebruiker om te delen met',
        macAddress: 'MAC-adres',
        battery: 'Batterij',
        deviceIsNotFound: 'Apparaat niet gevonden',
        nameIsTooShort: 'De naam is te kort',
        reset: 'Fabrieksreset',
        resetTomStatus: 'Status resetten',
        reportCatch: 'Besmetting documenteren',
        setOffline: 'Bevestig uitschakeling',
        heartbeatInterval: 'Berichten interval',
        occupancyRate: 'Bezettingsgraad',
        triggerCount: 'Aantal triggers',
        triggeredSince: 'Getriggerd sinds',
        catchCount: 'Aantal vangsten',
        traps: 'Vallen',
        noReportsNow: 'Er zijn momenteel geen berichten voor',
        noReportsForRange: 'Er zijn geen verslagen voor deze periode voor',
        noReportsYet: 'Er zijn nog geen rapporten',
        resetDescr: `Eerdere statistieken voor dit apparaat worden gewist. Furtermore de volgende instellingen worden gereset: Naam, Beschrijving, Hartslaginterval. Het apparaat wordt ingesteld op de status "Inactief"`,
        resetDescrNote: `Let erop dat u de batterij apart moet resetten.`,
        reportCatchDescr: `Weet u zeker dat u een besmetting wilt melden?`,
        reportCatchSelectReport:
            'Voor welke van de volgende berichten wil je een besmetting documenteren?',
        setOfflineDescr: `Hiermee bevestigt u dat u dit apparaat ter plaatse hebt uitgeschakeld. Het apparaat krijgt de status "Inactief"`,
        resetBatteryDescr: `Dit bevestigt dat u de batterijen van dit toestel ter plaatse hebt vervangen. De batterijteller wordt weer op 100% gezet.`,
        resetBattery: `Bevestig batterijwissel`,
        resetTOMStatusDescr:
            'De status van dit TOM-apparaat wordt teruggezet op "Online".',
        filters: {
            warning: 'Waarschuwingen',
            info: 'Apparaten online',
            inactive: 'Apparaten inactief',
            critical: 'Kritieke status'
        },
        online: 'Apparaten online',
        stock: 'Apparaten inactief',
        warning: 'Waarschuwingen',
        error: 'Kritieke status',
        qrCode: 'QR code',
        serialEmptyError: 'Serienummer bestaat niet voor dit apparaat.',
        catchDescription: 'Besmetting beschrijving',
        catchDescriptionMessage:
            'U kunt hier een beschrijving van de plaag opgeven',
        wifiSetSuccess: 'WiFi-gegevens succesvol ingesteld',
        wifiSetFail: 'Instellen van WiFi-gegevens mislukt',
        wifiSSID: 'WiFi SSID',
        wifiPassword: 'WiFi Wachtwoord',
        wifiPasswordMinLengthError: 'Moet langer zijn',
        wifiSSIDMinLengthError: 'Mag niet leeg zijn',
        wifiSignalStrength: 'Signaalsterkte',
        wifiSignalStrengthHover: 'Gebaseerd op de laatste Hartslag',
        wifiExcellent: 'Zeer goed',
        wifiGood: 'Goed',
        wifiLow: 'Zwak',
        wifiBad: 'Slecht',
        wifiUnknown: 'Onbekend',
        operationMode: {
            movement: 'Beweging',
            snaptrap: 'Valstrikken',
            insect: 'Insecten',
            bait: 'Aas'
        },
        operationModeInsect: 'Insecten',
        tom: 'TOM',
        jerry: 'JERRY',
        deviceTypes: {
            tom: 'TOM',
            jerry: 'JERRY',
            'jerry-lora': 'JERRY-LoRa',
            'tm01-1': 'TrapMe',
            trapsensor: 'TrapSensor',
            'jerry-bait-rat': 'JERRY-Bait-Rat'
        },
        deviceOperationMode: 'Werkingsmodus',
        deviceType: 'Type apparaat',
        routerType: 'Type router',
        insectModeTooltip: 'Deze unit werkt in insectenmodus',
        snaptrapModeTooltip: 'Deze unit werkt in de valstrikmodus.',
        movementModeTooltip: 'Deze unit draait in de bewegingsmodus',
        baitModeTooltip: 'Deze unit werkt in aasmodus',
        rearmed: 'Gespannen',
        inactive: 'Inactief',
        deviceIsInactive: 'Het apparaat is nu inactief.',
        deviceStatuses: {
            0: 'Inactief',
            1: 'Actief',
            2: 'Heartbeat Fout',
            3: 'Getriggerd',
            4: 'Batterij bijna leeg',
            5: 'Locate Mode',
            6: 'Instabiele verbinding',
            7: 'Lichte besmetting',
            8: 'Ernstige besmetting',
            9: 'Valse triggering',
            10: 'Activiteit (Waarschuwing)',
            11: 'Activiteit (Kritisch)'
        },
        deviceStatusDescription: {
            0: 'Het apparaat is nu inactief.',
            1: 'Het apparaat werkt naar behoren.',
            2: 'Met het oog op een permanente bewaking zendt het toestel periodiek een statusupdate naar de server - de zogenaamde heartbeat. Dit bericht betekent dat de laatste heartbeat niet heeft plaatsgevonden.',
            3: 'Een snapval is geactiveerd en moet persoonlijk worden gecontroleerd.',
            4: 'De batterijen van het apparaat zijn bijna leeg. Gelieve de batterijen te vervangen of op te laden.',
            5: 'Het toestel is in locate mode en kan gelokaliseerd worden.',
            6: 'Tijdens een testperiode is vastgesteld dat de draadloze verbinding onstabiel is. We raden aan om ofwel het WiFi-netwerk uit te breiden of het apparaat te verplaatsen.',
            7: 'Een gebruiker meldde een licht infestatie voor dit apparaat.',
            8: 'Een gebruiker meldde een zware besmetting voor dit apparaat.',
            9: 'Een gebruiker meldde een valse activering van een snap trap voor dit apparaat.',
            10: 'Een gebruiker meldde activiteit op dit apparaat.',
            11: 'Een gebruiker meldde kritische activiteit op dit apparaat.'
        },
        deviceStatusShortDescription: {
            0: 'Inactief',
            1: 'Actief',
            2: 'Heartbeat Fout',
            3: 'Getriggerd',
            4: 'Batterij bijna leeg',
            5: 'Locate Mode',
            6: 'Instabiele verbinding',
            7: 'Lichte besmetting',
            8: 'Ernstige besmetting',
            9: 'Valse triggering',
            10: 'Activiteit (Waarschuwing)',
            11: 'Activiteit (Kritisch)'
        },
        deviceLastReportTypeShortDescription: {
            0: 'Online', // successfully_set_up
            1: 'Online', // restarted
            2: 'Getriggerd',
            3: 'Online', // rearmed
            '3-bait': 'Aas aanwezig',
            4: 'Heartbeat Fout',
            5: 'Mislukt',
            6: 'Locate Mode',
            11: 'Online', // online_again
            12: 'Inactief',
            13: 'Instabiele verbinding',
            15: 'Lichte besmetting',
            16: 'Ernstige besmetting',
            17: 'Valse triggering',
            18: 'Activiteit (Waarschuwing)',
            19: 'Activiteit (Kritisch)',
            20: 'Vangst',
            21: 'Activiteit opgemerkt',
            22: 'Activiteitsdrempel bereikt',
            23: 'Het aas laag',
            24: 'Activiteitsdrempel bereikt en het aas laag',
            25: 'Activiteitsdrempel gereset'
        },
        changeOperationMode:
            'U hebt een andere modus gekozen. Schakel uw TOM-unit ter plaatse uit en weer in, zodat de wijziging van kracht wordt.',
        pestControlSystemLabel: 'Vallen systeem',
        pestControlSystemNotSelected: 'Niet geselecteerd',
        pestControlSystems: {
            1: 'AF-Box (Rat)',
            2: 'nagtag (Muis)',
            3: 'nagtag (Rat)',
            4: 'Metalen Tunnel (Rat)',
            5: 'SpeedBreak (Muis)',
            6: 'GSG (Muis)',
            7: 'Flexibele Standaard',
            8: 'Heisenberg Kakkerlakkendetector',
            9: 'Agrisense Mot Trechterval',
            10: 'UV Vliegenval (willekeurig)',
            11: 'GSG (Rat)'
        },
        deviceActions: 'Apparaatacties',
        serialNumberSearchModal: {
            header: 'Zoek de lijst met serienummers',
            subHeader:
                'Hier kunt u de lijst met serienummers van de apparaten invoegen, met elk serienummer op een nieuwe regel, als volgt:',
            placeHolder: 'Serienummers'
        },
        tableConfigurationModal: {
            header: 'Tabelkolommen configureren',
            subHeaderMainly: 'Voornamelijk gebruikt',
            subHeaderAdditional: 'Extra'
        },
        moveDevicesModal: {
            header: {
                1: 'Waar moet het naartoe?',
                2: 'Verplaats appara(a)t(en) naar locatie'
            },
            totalNumber: 'Totaal aantal:'
        },
        configureTableLabel: 'Tabel configureren',
        history: 'Geschiedenis',
        move: 'Verplaatsen',
        pestControlSystem: 'Systeem',
        transferMode: 'Overdrachtsmodus',
        cellular: 'Mobiel',
        connectedGateway: 'LoRa-gateway',
        gatewayNotFound: 'Gateway niet gevonden',
        gatewayLastSignal: 'Laatste signaal',
        notAssigned: 'Niet toegewezen',
        moveDToL: 'Apparaten naar locatie verplaatsen',
        youAreNotAbleToMoveTheseDevices:
            'U kunt deze apparaten niet verplaatsen omdat de locaties waar ze zich bevinden niet aan u zijn toegewezen of omdat u alleen leestoegang voor deze apparaten heeft. Controleer uw rol of neem contact op met uw organisatiebeheerder.',
        devicesAmount: 'Aantal apparaten',
        noDevicesYouCanMove:
            'Er zijn geen apparaten die u naar een andere locatie kunt verplaatsen vanuit de locaties die u hebt geselecteerd',
        devicesReadyToMove:
            'Deze apparaten zijn klaar om te worden verplaatst.',
        devicesSelected: 'Geselecteerd',
        moveToLocation: 'Naar locatie verplaatsen',
        delete: 'Verwijderen',
        youAreNotAbleToDeleteTheseDevices:
            'U kunt deze apparaten niet verwijderen omdat de locaties waar ze zich bevinden niet aan u zijn toegewezen of omdat u geen verwijderingsrechten voor deze apparaten heeft. Controleer uw rol of neem contact op met uw organisatiebeheerder.',
        devicesRemovedFromOrg:
            'Apparaten zijn succesvol verwijderd uit de organisatie',
        deleteDevicesFromOrg: 'Apparaten uit uw organisatie verwijderen',
        noDevicesYouCanDelete: 'Er zijn geen apparaten die u kunt verwijderen',
        devicesReadyToDelete:
            'Deze apparaten zijn klaar om te worden verwijderd.',
        areYouSureYouWantToDeleteDevices:
            'Weet u zeker dat u apparaten wilt verwijderen? De apparaten worden uit uw account verwijderd en zullen niet meer zichtbaar zijn in de apparatenlijst.',
        devicesSwitchedOffSuccessfully:
            'Apparaten zijn succesvol uitgeschakeld',
        noDevicesYouCanSwitchOff:
            'Er zijn geen apparaten waarvoor u het uitschakelen kunt bevestigen',
        devicesReadyToSwitchOff:
            'Deze apparaten zijn klaar om te worden uitgeschakeld.',
        areYouSureYouWantToConfirmSwitchOff:
            'Weet u zeker dat u het uitschakelen van deze apparaten wilt bevestigen? Dit bevestigt dat u de apparaten ter plaatse heeft uitgeschakeld. De apparaten krijgen de status "Inactief"',
        devicesSwitchedOnMModeSuccessfully:
            'Onderhoudsmodus is succesvol ingeschakeld',
        noDevicesYouCanSwitchOnMMode:
            'Er zijn geen apparaten waarvoor u de onderhoudsmodus kunt inschakelen',
        forTheseDevicesYouCanSwitchOnMMode:
            'Voor deze apparaten kunt u de onderhoudsmodus inschakelen.',
        areYouSureYouWantToConfirmSwitchOnMMode:
            'Weet u zeker dat u de onderhoudsmodus voor deze apparaten wilt inschakelen? In de onderhoudsmodus worden er geen rapporten gemaakt en geen meldingen verzonden.',
        youAreNotAbleToSwitchOffTheseDevices:
            'U kunt deze apparaten niet uitschakelen omdat de locaties waar ze zich bevinden niet aan u zijn toegewezen of omdat u geen bijwerkrechten voor deze apparaten heeft. Controleer uw rol of neem contact op met uw organisatiebeheerder.',
        youAreNotAbleToSwitchOnMModeTheseDevices:
            'U kunt de onderhoudsmodus voor deze apparaten niet inschakelen omdat de locaties waar ze zich bevinden niet aan u zijn toegewezen of omdat u geen bijwerkrechten voor deze apparaten heeft. Controleer uw rol of neem contact op met uw organisatiebeheerder.',
        areYouSureConfirmReplacementOfBait:
            'Weet u zeker dat u de vervanging van het aas wilt bevestigen?',
        areYouSureYouWantToResetTheActivityThreshold:
            'Weet u zeker dat u de activiteitsdrempel wilt resetten?',
        baitMonitoring: 'Aasbewaking',
        enablesOrDisablesBaitWeightTracking: 'Schakelt aasbewaking in of uit',
        activityAlertThreshold: 'Activiteitsdrempel',
        whenTheNotificationAlertShouldBeTriggered:
            'Bij hoeveel activiteiten wilt u een melding ontvangen?',
        per: 'per',
        hours: 'uren',
        days: 'dagen',
        baitType: 'Aastype',
        whichBaitAreYouUsing: 'Welk aas / gewicht gebruikt u?',
        calibration: 'Aasdrempel',
        notifiedWhenBaitWeightLowerThan:
            'Op welk gewicht is de aasplaat gekalibreerd? Bij dit restgewicht ontvangt u een melding.',
        baitPad: 'Aasplaat',
        replaceBait: 'Aas vervanging bevestigen',
        resetsTheBaitStatusToAvailable:
            'Stelt het tijdstip van de laatste aasvervanging in',
        lastReplacement: 'Laatste aasvervanging',
        baitLowCount: 'Totaal aantal aasverbruik',
        activityCount: 'Totaal aantal activiteiten',
        activitiesThreshold: 'Activiteitsdrempel',
        last: 'laatste',
        lastThresholdReset: 'Laatste reset van activiteitsdrempel',
        activities: 'Activiteiten',
        activitiesSummary: 'Activiteitenoverzicht',
        trackActivitiesInsights: 'Overzicht van activiteiten',
        bait: 'Aas',
        baitAvailable: 'Aas beschikbaar',
        baitLow: 'Aasniveau laag',
        baitStatusDebounceInfo:
            "De statussen 'Aasniveau laag' en 'Aas beschikbaar' worden pas bijgewerkt nadat er {{minutes}} minuten geen beweging op de aasplaat is gedetecteerd. Schakel bij het instellen van het apparaat de <bold>Onderhoudsmodus</bold> in, zodat de status in realtime wordt weergegeven.",
        manufacturerAndType: 'Fabrikant / Type',
        overrideLocationSettings:
            'Afzonderlijke bewakingswaarden voor dit apparaat gebruiken',
        overrideLocationSettingsDescription:
            'Schakel dit in als dit apparaat andere waarden voor lokaasgewicht of activiteit nodig heeft dan de andere apparaten op deze locatie. Deze waarden blijven actief totdat u dit uitschakelt of het apparaat reset.',
        deviceSettingsSource: 'Gebruikt apparaatinstellingen',
        monitoringValuesSetForLocation: 'Gebruikt instellingen van',
        baitAndActivitySettings: 'Instellingen voor lokaas en activiteit',
        locationSettingsOverrideMoveWarningTitle:
            'Afzonderlijke instellingen behouden?',
        locationSettingsOverrideMoveWarningText:
            'Een of meer geselecteerde apparaten hebben eigen instellingen voor lokaasgewicht of activiteit. Na het verplaatsen blijven deze instellingen op de apparaten staan. De instellingen van de nieuwe locatie worden niet toegepast.',
        locationSettingsOverrideMoveConfirm:
            'Verplaatsen en instellingen behouden'
    },
    reports: {
        sentAutomatically: 'Automatisch verzonden',
        noSharingHistory: 'Geen deelgeschiedenis',
        sharingHistory: 'Deelgeschiedenis',
        sharedBy: 'av',
        toEmails: 'til',
        ccEmails: 'cc',
        filterFrom: 'Van',
        filterTo: 'Naar',
        allReports: 'Alle Berichten',
        reports: 'Berichten',
        deviceName: 'DeviceName',
        deviceSerial: 'Serienummer',
        event: 'Bericht',
        time: 'Tijd',
        location: 'Locatie',
        organisation: 'Bedrijf',
        status: 'Status',
        type: 'Type',
        share: 'Deel',
        sendMessage: 'Bericht versturen',
        message: 'Berichten',
        cancle: 'Annuleren',
        emailSentSuccess: 'Email succesvol verzonden',
        emailSentFail: 'Oeps! Er is iets misgegaan',
        send: 'Versturen',
        sendReport: 'Verzend Rapport',
        on: ' op ',
        sentAt: 'Geplaatst: ',
        failToSend: 'Mislukking: ',
        mailMessageBegin: 'Demes en heren,',
        mailMessageMainSection:
            'we hebben een activering gedetecteerd van snap trap ',
        mailMessageMainSection2: '',
        mailMessageMainSection3:
            'Controleer de val zo snel mogelijk op vangst.',
        mailMessageEnd: 'Vriendelijke groeten ',
        mailMessageEnd2: 'FA. Fleschhut',
        noReportsYet: 'Nog geen berichten',
        noReportsForRange: 'Geen berichten voor de geselecteerde periode',
        reportTime: 'Verslagdatum',
        evaluationTime: 'Waarderingsdatum',
        reportTypes: {
            0: 'Geconfigureerd',
            1: 'Opnieuw opgestart',
            2: 'Getriggerd',
            3: 'Gespannen',
            '3-bait': 'Aas aanwezig',
            4: 'Heartbeat Fout',
            5: 'Mislukt',
            6: 'Locate Mode',
            7: 'Locate Mode Fout',
            8: 'Modus veranderd',
            9: 'Succesvolle update',
            10: 'Batterij bijna leeg',
            11: 'Weer online',
            12: 'Uitgeschakeld',
            13: 'Instabiele verbinding',
            14: 'Geïnfecteerd',
            15: 'Lichte aantasting',
            16: 'Ernstige aantasting',
            17: 'Valse triggering',
            18: 'Activiteit (waarschuwing)',
            19: 'Activiteit (maatregel)',
            20: 'Vangst',
            21: 'Activiteit opgemerkt',
            22: 'Activiteitsdrempel bereikt',
            23: 'Het aas laag',
            24: 'Activiteitsdrempel bereikt en het aas laag',
            25: 'Activiteitsdrempel gereset'
        },
        reportTypesDescription: {
            0: 'Het apparaat is ingeschakeld, heeft verbinding gemaakt met de server en functioneert naar behoren.',
            1: 'Het apparaat is opnieuw opgestart en functioneert naar behoren.',
            2: 'Een snapval is geactiveerd en moet persoonlijk worden gecontroleerd.',
            3: 'De snapvallen zijn opnieuw gewapend en het apparaat functioneert nu naar behoren.',
            '3-bait': 'Er is aas aanwezig op de aasplaat.',
            4: 'Om permanente bewaking te garanderen, zendt het apparaat periodiek een statusupdate naar de server - een zogeheten heartbeat. Dit bericht betekent dat de laatste heartbeat niet heeft plaatsgevonden.',
            5: 'Het apparaat heeft gedurende langere tijd geen verbinding met de server gemaakt en moet persoonlijk worden gecontroleerd en zo nodig worden onderhouden.',
            6: 'Het toestel staat in locate mode en kan gelokaliseerd worden',
            7: 'De opsporingsmodus kon niet worden geactiveerd',
            8: 'De instellingen van het apparaat (bv. hartslaginterval) zijn bijgewerkt.',
            9: 'De firmware-update voor het apparaat is met succes geïnstalleerd',
            10: 'De batterijen van het apparaat zijn bijna leeg. Gelieve de batterijen te vervangen of op te laden.',
            11: 'Het apparaat heeft opnieuw verbinding kunnen maken met de server en werkt naar behoren.',
            12: 'Het apparaat werd uitgeschakeld en is nu inactief',
            13: 'Tijdens een testperiode is vastgesteld dat de draadloze verbinding onstabiel is. We raden aan om ofwel het netwerk uit te breiden of het apparaat te verplaatsen.',
            14: 'Voor deze val is door een gebruiker een besmetting (vangst) gemeld.',
            15: 'Een gebruiker heeft een licht infestatie gemeld voor dit apparaat.',
            16: 'Een gebruiker heeft een ernstige besmetting voor dit apparaat gemeld.',
            17: 'Er is een valse activering gemeld voor dit apparaat.',
            18: 'Een gebruiker heeft activiteit gemeld op dit toestel.',
            19: 'Een gebruiker heeft kritische activiteit op dit toestel gemeld.',
            20: 'Er is één vangst gedetecteerd. Handmatige controle vereist.',
            21: 'Er is een activiteit gedetecteerd',
            22: 'De ingestelde activiteitsdrempel is bereikt',
            23: 'Het aaspeil is laag',
            24: 'De ingestelde activiteitsdrempel is bereikt en het aaspeil is laag',
            25: 'De activiteitsdrempel is handmatig gereset'
        },
        info: 'Info',
        warning: 'Waarschuwing',
        critical: 'Kritisch',
        infested: 'Geïnfecteerd',
        infestedDescription: 'Toon infestatie gebeurtenissen',
        catch: 'Vangst',
        triggered: 'Geactiveerd',
        triggeredDescription: 'Toon de geactiveerde gebeurtenissen',
        connectivity: 'Connectiviteit',
        connectivityDescription: 'Toon de connectiviteit per apparaat',
        catchDescription: 'Besmetting beschrijving',
        settings: 'Instellingen',
        at: ' om ',
        comments: 'Opmerkingen',
        edit: 'Bewerk',
        delete: 'Verwijderen',
        save: 'Opslaan',
        deleteConfirmation:
            'Weet je zeker dat je de opmerking wilt verwijderen?',
        addComment: '+ Voeg commentaar toe',
        commentsAvailable: 'Er zijn opmerkingen bij dit rapport',
        enterCommentPlaceholder: 'voer commentaar in',
        commentEmptyEx: 'Voer een opmerking in',
        somethingWentWrong:
            'Er is iets misgegaan bij het maken van screenshots van de plattegrond',
        exportDenyMsg:
            'Selecteer een periode van minder dan 3 maanden voor de export. U kunt deze selecteren in de filters. De huidige periode is te lang voor export.',
        changeRTToFT: 'Rapporttype wijzigen naar valse activering',
        changeRTToFTDescr:
            'Is de val leeg? Voeg een opmerking toe en eventueel een foto van de val. Na bevestiging wordt dit vangstrapport gewijzigd in een rapport van valse activering',
        changeRTToCatch: 'Rapporttype wijzigen naar vangst',
        changeRTToCatchDescr:
            'Is er een vangst in de val? Voeg een opmerking toe en eventueel een foto van de val. Na bevestiging wordt dit rapport van valse activering gewijzigd in een vangstrapport'
    },
    userManagement: {
        userManagement: 'Gebruikersbeheer',
        users: 'Gebruikers',
        roles: 'Rol',
        roleName: 'Rol naam',
        customer: 'Bedrijf',
        actions: 'Acties',
        createNew: 'Creëer nieuwe',
        addFromAnotherOrg: 'Toevoegen van een ander bedrijf',
        noUsersFound: 'Geen gebruikers gevonden',
        emailIsEmpty: 'E-mail is leeg',
        isNotEmail: ' is geen geldig e-mailadres',
        fillInEmail: 'Voer een e-mailadres in voor de nieuwe gebruiker.',
        onlyToYourOrg: 'U kunt een gebruiker alleen aan uw bedrijf toevoegen',
        chooseRole: 'Kies aub een rol voor de gebruiker',
        verify: 'Verifiëren',
        add: 'Toevoegen',
        whichOrgToCreateUser:
            'Voor welk bedrijf wilt u een gebruiker aanmaken?',
        create: 'Creëren',
        pickOrgToDeleteUser:
            'Selecteer het bedrijf waar u de gebruiker van wilt verwijderen',
        sureDeleteUser: 'Weet u zeker dat u deze gebruiker wilt verwijderen?',
        sureDeleteUsers: 'Weet u zeker dat u deze gebruikers wilt verwijderen?',
        nameIsTooShort: 'De naam is te kort',
        emailIsNotCorrect: 'E-mail is niet correct',
        genPassword: 'Genereer wachtwoord',
        changePassword: 'Wijzig wachtwoord',
        noRolesFound: 'Er zijn geen rollen gevonden',
        component: 'Component',
        read: 'Lees gegevens',
        update: 'Gegevens bijwerken',
        delete: 'Verwijder gegevens',
        roleNotFound: 'Rol werd niet gevonden',
        defaultRoles: {
            [DEFAULT_ROLES.traplinked_admin]: 'traplinked beheerder',
            [DEFAULT_ROLES.customer_admin]: 'Organisatiebeheerder',
            [DEFAULT_ROLES.viewer]: 'Waarnemer',
            [DEFAULT_ROLES.management_user]: 'Manager',
            [DEFAULT_ROLES.read_only_user]: 'Alleen-lezen gebruiker',
            [DEFAULT_ROLES.location_management_user]: 'Locatiebeheer gebruiker',
            [DEFAULT_ROLES.technician]: 'Technicus'
        },
        youCanNotDeleteThisUser: 'U mag deze gebruiker niet verwijderen',
        youCanNotDeleteThisRole: 'Je kunt deze rol niet verwijderen',
        internalUser: 'Interne gebruiker',
        externalUser: 'Externe gebruiker',
        createUserModalTitle: 'Nieuwe gebruiker aanmaken',
        createExternalTitle: 'Externe gebruiker aanmaken',
        createInternalTitle: 'Interne gebruiker aanmaken',
        userRalationStepTitle: 'Selecteer gebruikersrelatie',
        credentialsStepTitle: 'Login & Paswoord',
        createRoleStepTitle: 'Nieuwe rol aanmaken',
        selectRoleStepTitle: 'Selecteer rol voor gebruiker',
        selectLocationsStepTitle: 'Locaties toewijzen',
        reviewStepTitle: 'Final reviewBeoordeling',
        nextStep: 'Volgende stap',
        stepBack: 'Stap terug',
        completeBtn: 'Ok',
        backToDefaultRoles: 'Terug naar de standaard rollen',
        userRalationOptionName: {
            [USER_RELATIONS.internal]: 'Interne gebruiker',
            [USER_RELATIONS.external]: 'Externe gebruiker'
        },
        userRalationOptionDescription: {
            [USER_RELATIONS.internal]:
                'Nieuwe gebruikersaccount voor een persoon die in uw organisatie werkt, geschikt voor uw werknemer die nog geen account heeft in het traplinked systeem',
            [USER_RELATIONS.external]:
                'Nieuwe gebruikersaccount/toegang tot uw organisatie vanuit een externe organisatie, geschikte contractanten die nog geen gebruikersaccount hebben of er al een hebben'
        },
        firstName: 'Voornaam',
        lastName: 'Naam',
        password: 'Paswoord',
        customerName: 'Naam van de organisatie',
        userRelationExplanation: {
            [RELATIONS.internal]:
                'De gebruiker met deze e-mail bestaat al in uw organisatie als een interne',
            [RELATIONS.externalIn]:
                'De gebruiker met deze e-mail bestaat al in uw organisatie als een externe',
            [RELATIONS.externalOut]:
                'U kunt deze gebruiker alleen als externe aan de organisatie toevoegen. Wil je doorgaan?',
            [RELATIONS.nonexistent]: ''
        },
        roleNames: {
            [DEFAULT_ROLES.customer_admin]: 'Administrator',
            [DEFAULT_ROLES.viewer]: 'Viewer',
            [DEFAULT_ROLES.management_user]: 'Manager',
            [DEFAULT_ROLES.technician]: 'Technician',
            [CUSTOM_ROLE]: 'Custom'
        },
        roleDescription: {
            [DEFAULT_ROLES.customer_admin]:
                'Volledige toegang tot machtigingen in het systeem: beheer van locaties, apparaten, gebruikers en rest',
            [DEFAULT_ROLES.viewer]:
                'Heeft geen toegang tot gebruikersbeheer, kan alleen toegewezen sites bekijken, status van apparaten zien, rapporten van toegewezen sites',
            [DEFAULT_ROLES.management_user]:
                'Kan sites maken en beheren maar niet verwijderen, kan apparaten en rapporten beheren, kan gebruikers beheren maar niet verwijderen',
            [DEFAULT_ROLES.technician]:
                'Heeft geen toegang tot gebruikersbeheer, kan toegewezen sites creëren, beheren en verwijderen, kan apparaten en rapporten van toegewezen sites beheren',
            [CUSTOM_ROLE]: 'Nieuwe rol'
        },
        createNewCustomrole: '+ Maak een nieuwe Aangepaste Rol',
        selectExistingCustomRole: 'Selecteer aangepaste rol',
        deselectAllLocations: 'Alles deselecteren',
        selectAllLocations: 'Selecteer alle',
        showTheUserInTheList: 'toon de gebruiker in de lijst',
        youCanProceedWithRoleSelection:
            'U kunt doorgaan met de rolselectie voor deze externe gebruiker',
        sendInvitationMail: 'Stuur uitnodiging e-mail',
        invitationModalText:
            'Weet u zeker dat u de uitnodiging naar deze gebruiker wilt sturen?',
        usersStillAssigned: 'Gebruikers zijn nog steeds toegewezen aan die rol',
        usersAssignedTheRole:
            'Er zijn nog gebruikers toegewezen aan de rol die je wilt verwijderen',
        reassignThatUsers:
            'Wijs die gebruiker een andere rol toe voordat je deze verwijdert',
        deleteRoleConfirmation:
            'Weet je zeker dat je deze rol wilt verwijderen?',
        reassignAndDeleteModal: {
            header: 'Gebruikers zijn nog steeds toegewezen aan die rol',
            textOne:
                'Er zijn nog steeds gebruikers toegewezen aan de rol die u wilt verwijderen',
            textTwo:
                'Wijs deze gebruikers alstublieft een andere rol toe voordat u deze verwijdert'
        }
    },
    sharing: {
        sharing: 'Delen',
        chooseUsers: 'Kies gebruiker',
        chooseItems: 'Kies wat u wilt delen',
        confirmAndShare: 'Bevestigen en dele',
        organisation: 'Bedrijf',
        noUsersToShare: 'Nog geen gebruikers van een ander bedrijf toegevoegd.',
        pleaseAddUsers:
            'Gelieve gebruikers van een ander bedrijf toe te voegen',
        userMgmt: ' Gebruikersbeheer',
        noUsersLeft: 'Geen gebruikers meer te selecteren',
        noUsersSelected: 'Nog geen gebruikers geselecteerd',
        locations: 'Locaties',
        devices: 'Apparaten',
        reports: 'Berichten',
        serialNr: 'Serienummer',
        noDevicesToShare: 'Geen apparaten beschikbaar om te delen',
        noDevicesLeft: 'Geen apparaten meer te selecteren',
        noDevicesSelected: 'Nog geen apparaten geselecteerd',
        noReportsToShare: 'Er zijn momenteel geen verslagen om te delen',
        noReportsLeft: 'Geen berichten beschikbaar voor selectie',
        noReportsSelected: 'Nog geen berichten geselecteerd',
        address: 'Adres',
        noLocationsToShare: 'Er zijn momenteel geen locaties om te delen',
        contactSupport:
            'Als u dit bericht ziet, neem dan contact op met support.',
        noLocationsLeft: 'Geen locaties meer om uit te kiezen',
        noLocationsSelected: 'Geen locaties geselecteerd',
        willBeSharedWith: 'Zal worden gedeeld met:',
        successShare: 'Succesvol gedeeld'
    },
    detachedSharing: {
        noDataToShare: 'Geen gegevens beschikbaar om te delen',
        chooseUsers: 'Kies gebruikers',
        chooseItems: 'Kies wat u wilt delen',
        confirmAndShare: 'Bevestigen en delen',
        noDevicesSetupYet: 'Nog geen apparaten op deze locatie',
        devicesSelected: 'Geselecteerde apparaten',
        locationsSelected: 'Geselecteerde locaties',
        selected: 'Geselecteerd',
        shareWithUsers: 'Delen met gebruikers',
        existingFromAnotherOrg: 'toegevoegd door een ander bedrijf',
        byEmailFromAnotherOrg: 'per e-mail',
        noUsersToShare:
            'Nog geen gebruikers van een ander bedrijf toegevoegd. U kunt delen via e-mail.',
        usersSelected: 'Geselecteerde gebruikers',
        plsTypeInEmail: 'Voer een geldig e-mailadres in',
        chooseRole: 'Gelieve een rol te kiezen',
        addUsersEmails: 'Voeg e-mailadressen van gebruikers toe',
        location: 'Locatie',
        device: 'Apparaat',
        serialNr: 'Serienummer',
        dataForSharing: 'Gegevens om te delen',
        willBeSharedWith: 'Zal worden gedeeld met',
        locationsPath: 'Locatie pad',
        nothingFound: 'Niets gevonden'
    },
    settings: {
        faq: 'FAQ',
        language: 'Taal',
        settings: 'Instellingen',
        logout: 'Uitloggen',
        pushNotificationsEnabled: 'Push kennisgeving',
        emailNotificationsEnabled: 'E-mail kennisgeving',
        smsNotificationsEnabled: 'SMS kennisgeving',
        trapsTriggeredNotificationsEnabled: 'Triggermelding',
        trapsInactiveemailNotificationsEnabled: 'Apparaat mislukt',
        batteryEmptyNotificationsEnabled: 'Batterij bijna leeg',
        batterySetupNotificationsEnabled: 'Apparaat succesvol ingesteld',
        trapOnlineNotificationsEnabled: 'Apparaat weer online',
        unstableConnectionNotificationsEnabled:
            'Apparaat heeft een instabiele verbinding',
        baitLowNotificationsEnabled: 'Apparaat heeft laag aasniveau',
        activityThresholdReachedNotificationsEnabled:
            'Apparaat heeft activiteitsdrempel bereikt',
        baitLowAndActivityThresholdReachedNotificationsEnabled:
            'Apparaat heeft laag aasniveau en heeft activiteitsdrempel bereikt',
        acceptSharedData: 'Werk gedeelde gegevens bij',
        notificationsChannels: 'Meldingskanalen',
        phoneNumberErr: 'Telefoonnummer is niet geldig',
        organisationPhoneNumberErr:
            ' Het telefoonnummer van de organisatie is niet geldig',
        notificationsEvents: 'Meldingsgebeurtenissen',
        nameIsTooShort: 'De naam is te kort',
        reportBug: 'Een bug melden',
        viewOurRoadmap: 'Onze routekaart bekijken',
        voteOnNewFeatures: 'Stemmen over nieuwe functies',
        termsOfService: 'Servicevoorwaarden',
        termsConditions: 'Algemene voorwaarden',
        privacyPolicy: 'Privacybeleid',
        simCards: 'SIM-kaarten',
        billingPortal: 'Facturering',
        portalError: 'Fout bij het laden van het Stripe-factureringsportaal'
    },
    simCards: {
        simCard: 'SIM-kaart',
        simCardSerialNumber: 'SIM-kaartnummer',
        activate: 'Activeren',
        deactivate: 'Deactiveren',
        addSimCardLabel: 'SIM-kaart toevoegen',
        addSimCardTooltipText:
            'Er is geen SIM-kaart toegewezen aan dit netwerkapparaat. U kunt deze handmatig toevoegen',
        simCardEmptyError: 'Mag niet leeg zijn',
        simCardNotValidIccidError: 'Ongeldig SIM-kaartnummer-formaat',
        pendingStatusText:
            'De status van de SIM-kaart wordt gewijzigd, dit kan tot 5 minuten duren',
        standByStatusText:
            'De SIM-kaart wacht om gegevens te verzenden en wordt actief zodra dit gebeurt',
        billingDetails: {
            totalSimCardsText: 'Geactiveerde netwerkapparaten',
            totalSimCardsTextItalic: '(Huidige maand)',
            billing: 'Facturatie',
            tooltipText:
                'Het bedrag wordt automatisch van uw account afgeschreven op de laatste dag van elke maand',
            currencySymbol: '€'
        }
    },
    login: {
        emailIsRequired: 'Een e-mailadres is vereist om in te loggen',
        passwordIsRequired: 'Vereist een wachtwoord om in te loggen',
        forgotPassword: 'Wachtwoord vergeten?',
        signIn: 'Inloggen',
        newInTraplinked: 'Nieuwe klant? U kunt zich hier inschrijven.'
    },
    twoFactor: {
        title: 'Twee-factor authenticatie',
        helperText:
            'Voer de 6-cijferige code in die we hebben gestuurd naar uw e-mail',
        verify: 'Verifiëren',
        backToLogin: 'Terug naar inloggen'
    },
    resetPassword: {
        resetPassword: 'Wachtwoord opnieuw instellen',
        backToLogin: 'Terug naar de inschrijvingspagina',
        goToLogin: 'Naar de inschrijvingspagina',
        passwordIsTooShort: 'Wachtwoord is te kort',
        passwordsDoNotMatch: 'Wachtwoorden komen niet overeen'
    },
    register: {
        nameIsTooShort: 'De naam is te kort.',
        emailIsNotCorrect: 'E-mailadres is onjuist',
        passwordIsTooShort: 'Het wachtwoord is te kort',
        passwordsDoNotMatch: 'De wachtwoorden komen niet overeen',
        registerUser: 'Registreer gebruiker',
        haveAlreadyUser: 'Hebt u al een gebruikersaccount? Log hier in.',
        pleaseEnterOrgName: 'Gelieve de naam van uw bedrijf in te vullen.',
        orgName: 'Bedrijfsnaam',
        registerOrg: 'Bedrijf creëren',
        everythingIsReady:
            'Uw gebruikersaccount is succesvol aangemaakt. Log nu in.',
        goToLogin: 'Ga naar de inlogpagina',

        registerYourOrganization: 'Registreer je organisatie',
        youAreAPestController:
            'Je bent een ongediertebestrijder en wilt je organisatie registreren',
        alreadyHaveAnAccount: 'Heb je al een account?',
        login: 'Aanmelden',
        or: 'Of',
        joinAnExistingOrganization: 'Aansluiten bij een bestaande organisatie?',
        accessYourOrganization:
            'Als je een technicus of een teamlid bent die toegang wil krijgen tot je organisatie, vraag dan je Admin om je uit te nodigen.',
        notSureWhoYourAdmin:
            'Weet je niet zeker wie je Admin is of heb je problemen? Neem contact op met ons ondersteuningsteam voor hulp.'
    },
    apiKeys: {
        apiKeys: 'API Sleutel',
        apiKey: 'API Sleutel',
        viewDocs: 'View REST docs',
        copied: 'Gekopieerd',
        failedToCopy: 'Fout bij het kopiëren',
        createNew: 'Creëer nieuwe',
        expires: 'Vervalt',
        noApiKeysFound: 'Er zijn geen API-sleutels gevonden',
        plsProvideDescr:
            'Vul bijvoorbeeld in de beschrijving de naam in van de software waarin u de API-sleutel invoert.',
        deleteKeyDescr:
            'Als u deze API sleutel verwijdert, zult u niet langer toegang hebben tot de gegevens met deze API sleutel. Weet u zeker dat u deze API sleutel wilt verwijderen?',
        viewKeyDescr:
            'Voer de API-sleutel in de software in zodat deze uw apparaatgegevens kan bekijken. Als de fabrikant hiervoor een functie biedt, kunt u ook de QR-code scannen om de API-sleutel in te voeren.'
    },
    integrations: {
        integrations: 'Integraties',
        documentationTools: 'Documentatietools',
        apiKeys: 'API-sleutels',
        pestsoft: 'Pestsoft',
        debuxx: 'DEBUXX',
        pestscan: 'Pestscan',
        pestscanPcoId: 'Pestscan PCO ID',
        username: 'Gebruikersnaam',
        enterPassword: 'Voer wachtwoord in',
        credentialsRequired:
            'Voer inloggegevens in en sla ze op om de verbinding te voltooien.',
        pestscanPcoIdRequiredWhenEnabled:
            'PCO ID is verplicht wanneer Pestscan is ingeschakeld.',
        debuxxHint: {
            toggle: 'Hoe verkrijg ik deze inloggegevens?',
            title: 'Een DEBUXX API-gebruiker aanmaken',
            body: 'Beheerders kunnen in DEBUXX onder **Einstellungen → Erweiterungen** een nieuwe API-gebruiker aanmaken door een gebruikersnaam en wachtwoord te kiezen. Kopieer ze hierheen om te verbinden.',
            support:
                'Hebt u meer hulp nodig? Neem contact op met de DEBUXX-ondersteuning als u nog vragen hebt over het aanmaken of ophalen van deze inloggegevens.'
        },
        pestscanHint: {
            toggle: 'Hoe verkrijg ik mijn PCO-ID?',
            title: 'Een PC40-profiel aanmaken in Pestscan',
            steps: {
                1: 'Ga via het tandwiel in de hoofdnavigatie naar **General Settings**.',
                2: 'Selecteer **Permanent Monitoring** in het menu.',
                3: 'Open het tabblad **Profiles** en klik op **New**.',
                4: 'Stel **Description** in op iets duidelijks, bijvoorbeeld PC40.',
                5: 'Stel **Type** in op PC40.',
                6: 'Klik op **Save**.',
                7: 'Kopieer de resulterende **PCO ID** en plak deze hier.'
            },
            support:
                'Hebt u meer hulp nodig? Neem contact op met de Pestscan-ondersteuning als u nog vragen hebt over het verkrijgen van uw PCO-ID.'
        },
        settingsUpdated: 'Integratie-instellingen bijgewerkt',
        settingsUpdateFailed:
            'Fout bij het bijwerken van integratie-instellingen',
        loadFailed: 'Fout bij het laden van integratie-instellingen',
        summaryTitle: 'Overzicht integraties & API',
        apiKeysCount: 'API-sleutels',
        webhooks: 'Webhooks',
        webhooksTab: {
            title: 'Webhooks',
            viewDocs: 'Webhook-documentatie openen',
            createWebhook: 'Webhook aanmaken',
            editWebhook: 'Webhook bewerken',
            deleteWebhook: 'Webhook verwijderen',
            confirmDeleteWebhook:
                'Dit verwijdert de webhook definitief. Deze actie kan niet ongedaan worden gemaakt.',
            noWebhooksFound: 'Nog geen webhooks',
            emptyBody:
                'Webhooks leveren apparaat-events in real-time aan uw endpoints. Maak er een aan om data te ontvangen.',
            editorSubtitle: 'Webhooks leveren apparaat-events in real-time',
            webhookCreated: 'Webhook aangemaakt',
            webhookUpdated: 'Webhook bijgewerkt',
            webhookDeleted: 'Webhook verwijderd',
            createFailed: 'Webhook kon niet worden aangemaakt',
            updateFailed: 'Webhook kon niet worden bijgewerkt',
            deleteFailed: 'Webhook kon niet worden verwijderd',
            loadFailed: 'Webhooks konden niet worden geladen',
            statusEnabled: 'Actief',
            statusDisabled: 'Inactief',
            saveChanges: 'Wijzigingen opslaan',
            cancel: 'Annuleren',
            never: '--',
            fields: {
                status: 'Status',
                name: 'Naam',
                description: 'Beschrijving',
                endpoint: 'URL',
                webhookType: 'Type',
                requestMethod: 'Methode',
                reasons: 'Meldingstypen',
                reasonSingular: 'meldingstype',
                reasonPlural: 'meldingstypen',
                reasonsTotalSuffix: 'beschikbaar',
                isEnabled: 'Actief',
                isEnabledHint:
                    'Wanneer actief, worden meldingen die overeenkomen met de geselecteerde meldingstypen geleverd.',
                headers: 'Headers',
                lastResponse: 'Laatste antwoord',
                lastResponseCode: 'Laatste antwoordcode',
                lastRequestTimestamp: 'Laatste verzoek'
            },
            placeholders: {
                name: 'Mijn webhook',
                endpoint: 'https://example.com/webhooks/traplinked',
                description: 'Waar is deze webhook voor?',
                reasonsEmpty: 'Selecteer een of meer meldingstypen…'
            },
            headers: {
                keyHeader: 'Sleutel',
                valueHeader: 'Waarde',
                keyPlaceholder: 'bijv. Authorization',
                valuePlaceholder: 'Waarde',
                addRow: 'Header toevoegen',
                removeRow: 'Header verwijderen',
                maskedHint: '•••••• opnieuw invoeren om te overschrijven',
                renamedHint: 'Hernoemd — voer de waarde opnieuw in',
                versionRequired: 'Verplicht',
                versionLatestHint: 'nieuwste is',
                versionLatestSuffix: 'nieuwste',
                empty: 'Nog geen aangepaste headers. Voeg er een toe om uw verzoeken te authenticeren.'
            },
            validation: {
                nameRequired: 'Naam is verplicht',
                endpointRequired: 'URL is verplicht',
                reasonsRequired: 'Selecteer minstens één meldingstype',
                headerKeyRequired: 'Header-sleutel is verplicht',
                headerValueRequired: 'Header-waarde is verplicht',
                headerKeyDuplicate: 'Header-sleutels moeten uniek zijn',
                versionReserved:
                    'traplinked-Version stelt u hierboven in, niet als aangepaste header'
            },
            reasonGroupLabels: {
                device: 'Apparaatstatus',
                trap: 'Val-meldingen',
                image: 'Afbeeldingen',
                heartbeat: 'Heartbeat',
                activity: 'Activiteit en aas'
            },
            reasonLabels: {
                image_received: 'Afbeelding ontvangen',
                image_ai_processed: 'Afbeelding door AI verwerkt',
                heartbeat_received: 'Heartbeat ontvangen',
                trap_triggered: 'Val geactiveerd',
                battery_low: 'Accu zwak',
                catch_detected: 'Vangst gedetecteerd',
                rearmed: 'Opnieuw scherp gezet',
                offline: 'Offline',
                online: 'Online',
                configured: 'Geconfigureerd (initiële fabrieksinstelling)',
                maintained: 'Onderhouden (fabrieksservice)',
                switched_off: 'Uitgeschakeld',
                catch_reported: 'Vangst gemeld',
                false_triggering: 'Valse activering',
                activity_noticed: 'Activiteit gedetecteerd',
                activity_threshold_reached: 'Activiteitsdrempel bereikt',
                bait_low: 'Aas-niveau laag',
                activity_threshold_reached_and_bait_low:
                    'Activiteitsdrempel bereikt en aas-niveau laag'
            },
            typeLabels: {
                traplinked: 'traplinked',
                rentokil_tom_images: 'Rentokil TOM-afbeeldingen',
                pestsoft: 'Pestsoft',
                axinsectai: 'AxInsectAI'
            },
            methodLabels: {
                post: 'POST',
                put: 'PUT',
                patch: 'PATCH',
                get: 'GET',
                delete: 'DELETE'
            }
        },
        billingNotice:
            'Actieve integraties en API-sleutels kosten €0,10 per apparaat per maand voor apparaten die sinds het begin van de maand minstens één keer een signaal hebben verstuurd. Apparaten aangemaakt op of vóór 31.12.2024 zijn vrijgesteld.',
        openBillingDashboard: 'Facturatiedashboard openen',
        billingDataLoadFailed:
            'Laden van integraties- en facturatieoverzicht mislukt',
        billingModalTitle: 'Deze activering heeft invloed op uw facturering',
        billingModalIntro:
            'Het activeren van een integratie, API-sleutel of webhook start de facturering voor uw organisatie. Details:',
        billingModalRulePrice: 'Kosten: €0,10 per apparaat per maand',
        billingModalRuleHeartbeat:
            'Alleen apparaten die binnen een maand minstens één signaal (heartbeat) hebben verstuurd worden in rekening gebracht',
        billingModalRuleGrandfathered:
            'Voor apparaten die sinds of vóór 31.12.2024 online zijn ontstaan geen kosten',
        billingModalConfirm: 'Ik ga akkoord, inschakelen',
        billingModalCancel: 'Annuleren'
    },
    sagasMsgs: {
        /* common */
        getReportSharingHistoryEx: 'Fout bij het ophalen van de geschiedenis',
        commonLoadingError: 'Er is iets fout gegaan. Probeer het opnieuw',
        /* login */
        loginEx: 'De inloggegevens zijn onjuist.',
        loginWithTsEx:
            'Er is een fout opgetreden, neem contact op met de ondersteuning.',
        sessionEx: 'Uw sessie is verlopen',
        verify2faEx: 'Ongeldige of verlopen code. Probeer het opnieuw.',
        updataProfileRes: 'Profiel is bijgewerkt.',
        updataProfileEx: 'Fout tijdens het bijwerken van profiel',
        pswdChangeRes: 'Wachtwoord is gewijzigd.',
        pswdChangeEx:
            'Fout bij wijzigen wachtwoord. Zorg ervoor dat het oude wachtwoord correct is.',
        forgotPswdRes:
            'Een link om uw wachtwoord te resetten is naar uw e-mailadres gestuurd.',
        forgotPswdEx: 'Fout bij het aanvragen van een nieuw wachtwoord',
        resetPswdRes:
            'Het wachtwoord is met succes gewijzigd. U kunt nu inloggen.',
        resetPswdEx:
            'Er is een fout opgetreden. Probeer het wachtwoord op de inlogpagina opnieuw in te stellen.',
        saveLocaleEx: 'Fout bij het opslaan van de taalinstelling',
        /* customers */
        getCustomersEx: 'Fout bij laden klanten',
        getCustomerEx: 'Fout bij laden klant',
        updateCustomerEx: 'Fout bij updaten klant',
        updateCustomerRes: 'De klant werd met succes bijgewerkt.',
        getSoftwarePlansEx: 'Fout bij laden softwareplannen',
        /* locations */
        getLocationsEx: 'Fout bij het laden van de locatie',
        getLocationEx: 'Fout bij het laden van de locatie',
        updateLocationRes: 'De locatie werd met succes bijgewerkt.',
        updateLocationEx: 'Fout bij het bijwerken van de locatie',
        createLocationRes: 'De locatie werd met succes aangemaakt.',
        createLocationEx: 'Fout bij het aanmaken van de locatie',
        deleteLocationRes: 'De locatie werd met succes verwijderd.',
        deleteLocationEx: 'Fout bij het verwijderen van de locatie',
        shareLocationRes: 'Succesvol gedeeld',
        shareLocationEx: 'Fout tijdens het delen',
        getLocationDevicesEx: 'Fout bij laden apparaat',
        getLocationReportsEx: 'Fout bij laden van berichten',
        getLocationSharedUsersEx: 'Fout bij laden van toegangsinformatie',
        getAvailableDevicesEx: 'Fout bij het laden van apparaten',
        moveDevicesRes:
            'De apparaten zijn met succes toegevoegd aan de locatie',
        moveDevicesEx: 'Fout bij het toevoegen van apparaten aan de site',
        createFloorPlanRes: 'De plattegrond is succesvol aangemaakt',
        createFloorPlanEx: 'Fout bij het maken van de plattegrond',
        getFloorPlanEx: 'Fout bij laden plattegrond',
        deleteFloorPlanRes: 'De plattegrond is succesvol verwijderd',
        deleteFloorPlanEx: 'Fout bij het verwijderen van een plattegrond',
        getFPAvailableDevicesEx: 'Fout bij het laden van apparaten',
        addDevicesToFPEx:
            'Fout bij het toevoegen van apparaten aan plattegrond',
        updateFPDeviceEx: 'Fout tijdens het updaten van het apparaat',
        deleteFPDeviceEx: 'Fout bij het verwijderen van het apparaat',
        /* devices */
        getDevicesEx: 'Fout bij het laden van apparaten',
        getDeviceEx: 'Fout bij laden apparaat',
        getDeviceReportsEx: 'Fout bij laden berichten',
        shareDevicesRes: 'Succesvol gedeeld',
        shareDevicesEx: 'Fout tijdens delen',
        resetDeviceRes: 'Het apparaat is gereset.',
        resetDeviceEx: 'Fout bij het resetten van het apparaat',
        reportCatchRes: 'De besmetting werd met succes gemeld.',
        reportCatchEx: 'Fout bij het melden van de besmetting',
        setOfflineRes: 'Het apparaat werd uitgeschakeld.',
        setOfflineEx: 'Fout bij het uitschakelen van het apparaat',
        batteryResetRes: 'De batterij is gereset.',
        batteryResetEx: 'Fout bij het resetten van de batterij',
        updateDeviceRes: 'Het apparaat is bijgewerkt.',
        updateDeviceEx: 'Fout bij het updaten van het apparaat',
        getPestControlSystems:
            'Fout bij laden van ongediertebestrijdingssystemen',
        tomStatusResetRes: 'Status werd gereset',
        tomStatusResetEx: 'Fout bij het resetten van de status',
        /* reports */
        getReportsEx: 'Fout bij laden van berichten',
        getReportEx: 'Fout bij het laden van het bericht',
        getLastReportDateEx:
            'Er is een fout opgetreden bij het laden van de datum van het laatste rapport',
        /* user mgmt */
        getUsersEx: 'Fout bij laden gebruikers',
        getUserEx: 'Fout bij laden gebruiker',
        getRoleEx: 'Fout bij laden rol',
        createRoleRes: 'Rol werd succesvol aangemaakt.',
        createRoleEx: 'Fout bij het aanmaken van de rol',
        updateRoleRes: 'De rol werd met succes bijgewerkt.',
        updateRoleEx: 'Fout bij het bijwerken van de rol',
        getRolesEx: 'Fout bij laden rollen',
        updateUserRes: 'De gebruiker werd bijgewerkt.',
        updateUserEx: 'Fout bij het updaten van de gebruiker',
        createUserRes: 'De gebruiker is succesvol aangemaakt.',
        createUserEx: 'Fout bij het aanmaken van de rol',
        deleteUserRes: 'De gebruiker werd met succes verwijderd.',
        deleteUserEx: 'Fout bij het verwijderen van de gebruiker',
        membershipEx: 'Fout bij het laden van het gebruikerslidmaatschap',
        addToOrgRes: 'De gebruiker werd met succes toegevoegd aan het bedrijf.',
        addToOrgEx: 'Fout bij toevoegen gebruiker aan bedrijf',
        sendInvitationRes:
            'Uitnodiging is succesvol verzonden naar de gebruiker',
        sendInvitationEx:
            'Er is een fout opgetreden tijdens het verzenden van de uitnodiging',
        deleteRoleRes: 'Rol is succesvol verwijderd',
        deleteRoleEx:
            'Er is een fout opgetreden bij het verwijderen van de rol',
        /* sharing */
        revokeSharingRes: 'Toegang werd met succes ingetrokken.',
        revokeSharingEx: 'Fout bij het intrekken van de toegang',
        getSharingDataEx: 'Fout bij laden van sharing component',
        shareEx: 'Fout bij het delen',
        /* api-keys */
        getApiKeysEx: 'Fout bij laden API sleutels',
        createApiKeyRes: 'De API-sleutel is succesvol aangemaakt.',
        createApiKeyEx: 'Fout bij het aanmaken van de API-sleutel',
        deleteApiKeyRes: 'De API-sleutel werd met succes verwijderd.',
        deleteApiKeyEx: 'Fout bij het verwijderen van de API-sleutel',
        getApiKeyEx: 'Fout bij laden API sleutel',
        /* register */
        registerUserRes: 'De gebruiker werd met succes aangemaakt.',
        registerUserEx: 'Fout bij het aanmaken van de gebruiker',
        registerCustomerRes: 'Het bedrijf is succesvol aangemaakt.',
        pleaseUseEmail:
            'Gebruik het e-mailadres en wachtwoord van de nieuwe gebruiker.',
        registerCustomerEx: 'Fout bij het aanmaken van het bedrijf',
        /* detached sharing */
        getDetachedSharingDataEx: 'Fout bij het laden van de sharing component',
        shareDetachedSharingDataRes: 'Succesvol gedeeld',
        shareDetachedSharingDataEx: 'Fout tijdens delen',
        tomMakeReport: 'Fout bij het maken van een rapport',
        getTomPicturesEx: 'Fout bij het laden van TOM afbeeldingen',
        mailSendRes: 'Email succesvol verzonden',
        mailSendEx: 'Kan geen email verzenden',
        organisationPhoneEx:
            'Kan het telefoonnummer van de organisatie niet opslaan',
        commentDeleteRes: 'Reactie succesvol verwijderd',
        commentDeleteEx:
            'Er is een fout opgetreden tijdens het verwijderen van commentaar',
        commentAddRes: 'Reactie succesvol toegevoegd',
        commentAddEx:
            'Er is een fout opgetreden bij het toevoegen van commentaar',
        commentEditRes: 'Reactie succesvol bewerkt',
        commentEditEx:
            'Er is een fout opgetreden tijdens het bewerken van commentaar',
        getCommentsEx: 'Er is een fout opgetreden bij het laden van reacties',
        deviceImagesAddRes: 'Met succes toegevoegd',
        deviceImagesAddEx:
            'Er is een fout opgetreden tijdens het toevoegen van',
        deviceImagesEditRes: 'Met succes bewerkt',
        deviceImagesEditEx:
            'Er is een fout opgetreden tijdens het bewerken van',
        getDeviceImagesEx: 'Er is een fout opgetreden tijdens het laden van',
        getLocationsByCustomerIdEx:
            'An error occurred while loading locations by customer id',
        getEscalationLevelEx:
            'Er is een fout opgetreden tijdens het laden van escalatieniveaus',
        postEscalationLevelEx:
            'Fout opgetreden bij het aanmaken van escalatieniveaus',
        postEscalationLevelRes: 'Succesvol escalatieniveaus toegevoegd',
        getDeviceHistoryEx:
            'Er is een fout opgetreden bij het laden van de apparaatgeschiedenis',
        getUserPreferencesByTypeEx:
            'Fout bij het laden van gebruikersvoorkeuren',
        patchUserPreferencesEx:
            'Fout bij het bijwerken van de gebruikersvoorkeuren',
        postUserPreferencesEx: 'Fout bij het maken van de gebruikersvoorkeuren',
        exportFileEx: 'Fout bij het exporteren van het bestand',
        getSimCardEx:
            'Er is een fout opgetreden bij het laden van de SIM-kaart',
        updateSimCardRes: 'SIM-kaart is succesvol bijgewerkt',
        updateSimCardEx:
            'Er is een fout opgetreden bij het bijwerken van de SIM-kaart',
        createSimCardRes: 'SIM-kaart is succesvol aangemaakt',
        createSimCardEx:
            'Er is een fout opgetreden bij het aanmaken van de SIM-kaart'
    },
    common: {
        maintenanceMode: 'Onderhoudsmodus',
        maintenanceDurationCustom: 'Aangepast',
        maintenanceDurationMinUnit: 'min',
        maintenanceDurationPositiveOnly:
            'Alleen positieve hele getallen zijn toegestaan',
        maintenanceDurationDecrease: 'Minuten verlagen',
        maintenanceDurationIncrease: 'Minuten verhogen',
        maintenanceDurationMinutes: 'Onderhoudsminuten',
        exitingMMode: 'Onderhoudsmodus wordt afgesloten',
        switchOnMMode: 'Onderhoudsmodus inschakelen',
        switchOffMMode: 'Onderhoudsmodus uitschakelen',
        switchOnMModeDescr:
            'In de onderhoudsmodus worden er geen rapporten gemaakt en geen meldingen verzonden.',
        switchOffMModeDescr: 'De onderhoudsmodus wordt uitgeschakeld.',
        ok: 'Ok',
        name: 'Naam',
        save: 'Opslaan',
        search: 'Zoeken',
        cancel: 'Annuleren',
        submit: 'Bevestig',
        clear: 'Filters resetten',
        phone: 'Mobiel nummer',
        organisationPhone: 'Organisatie Telefoon',
        email: 'E-mail',
        organisation: 'Bedrijf',
        role: 'Rol',
        password: 'Wachtwoord',
        passwordConfirmation: 'Bevestig wachtwoord',
        changePassword: 'Wijzig wachtwoord',
        oldPassword: 'Oud wachtwoord',
        newPassword: 'Nieuw wachtwoord',
        newPasswordConfiramtion: 'Bevestig nieuw wachtwoord',
        errorContactSupport:
            'Er is een fout opgetreden, neem contact op met support.',
        revoke: 'Herroepen',
        share: 'Aandeel',
        delete: 'Delete',
        back: 'Terug',
        next: 'Volgende',
        confirm: 'Bevestigen',
        skip: 'Overslaan',
        description: 'Beschrijving',
        trap: 'Vallen',
        fourHours: '4 uur',
        sixHours: '6 uur',
        twelveHours: '12 uur',
        eighteenHours: '18 uur',
        twentyFourHours: '24 uur',
        acceptTerms: 'Accepteren',
        loading: 'Laden',
        copied: 'Gekopieerd',
        failedToCopy: 'Fout bij het kopiëren',
        refresh: 'Bijwerken',
        confirmationCode: 'Veiligheidscode',
        passwordLength: 'Het wachtwoord heeft meer dan 8 tekens.',
        passwordSpecialChar: 'Het wachtwoord bevat speciale tekens.',
        passwordNumber: 'Het wachtwoord heeft een nummer.',
        passwordCapital: 'Het wachtwoord heeft een hoofdletter.',
        passwordLetter: 'Het wachtwoord heeft één letter.',
        nothingWasFound: 'Er is niets gevonden',
        update: 'Actualisering',
        newVersionIsAvailable: 'Nieuwe Web App Versie beschikbaar!',
        pleaseClickUpdate:
            'Druk rechts op "Actualiseren" om de toepassing bij te werken. Daarna zijn we klaar om te gaan!',
        required: 'Verplicht veld',
        passwordErrorMessage: 'Wachtwoord is niet sterk',
        notValidEmail: 'Ongeldige e-mail',
        assigned: 'Toegewezen',
        assignment: 'Toewijzing',
        accountSettings: 'Kontoeinstellungen',
        organisationSettings: 'Organisatie-instellingen',
        exportCsv: 'Export CSV',
        exportExcel: 'Export Excel',
        exportPdf: 'Export PDF',
        exportQrPdf: 'Exporteren met QR-code',
        done: 'Klaar',
        settings: 'Instellingen',
        createNew: 'Creëer nieuwe',
        fileTooBig: 'Het bestand is te groot',
        emailTo: 'Naar',
        emailCc: 'Cc',
        advancedInformation: 'Geavanceerde informatie',
        supportChat: 'Ondersteuningschat',
        account: 'Account',
        manual: 'Handleiding',
        support: 'Ondersteuning',
        about: 'Over',
        online: 'Online',
        offline: 'Offline',
        disconnected: 'Verbinding verbroken',
        notFilterable: 'Niet filterbaar',
        expandTreeNodes: 'Alle knooppunten uitklappen',
        collapseTreeNodes: 'Alle knooppunten inklappen',
        applyFilters: 'Filters toepassen',
        close: 'Sluit',
        login: 'Inloggen',
        installation: 'Installatie',
        success: 'Succes'
    },
    tom: {
        openTomBtnTitle: 'Nieuwe beelden voor herziening',
        loadMore: 'Meer laden',
        contentType: 'Type inhoud',
        reportType: 'Bericht',
        createdAt: 'Gemaakt',
        updatedAt: 'Bijgewerkt',
        status: 'Status',
        bedbug: 'Bug',
        ant: 'Mier',
        roach: 'Cockroach',
        moth: 'Mot',
        cockroach: 'Kakkerlak',
        fly: 'Insecten',
        other: 'Andere',
        mouse: 'Muis',
        rat: 'Rat',
        activated: 'Activeert',
        activity: 'Activiteit',
        falseTrigger: 'Valse triggering',
        reviseReport: 'Herzie de boodschap',
        openTom: 'Open TOM',
        user_processed: 'Beoordeeld door gebruiker',
        not_processed: 'Niet verwerkt',
        ai_processed: 'Verwerkt door AI',
        ai_and_user_processed:
            'Verwerkt door AI en geëvalueerd door de gebruiker',
        tomMode: 'Werkingsmodus',
        period: 'Periode',
        pileEmpty: 'Je stapel is leeg.',
        allProcessed: 'U heeft met succes alle nieuwe afbeeldingen beoordeeld.',
        deviceName: 'Apparaat',
        companyName: 'Organisatie',
        dateTime: 'Datum',
        operationMode: 'Werkingsmodus',
        ok: 'Ok',
        warning: 'Waarschuwing',
        critical: 'Kritisch',
        comments: 'Opmerkingen',
        aiProcessed: 'Verwerkt door AI',
        userProcessed: 'Beoordeeld door gebruiker',
        location: 'Locatie',
        system: 'Systeem',
        noDevicePictures: "Nog geen foto's.",
        noPictures: "Er zijn geen TOM foto's",
        notUsingTom: 'Gebruikt u ons nieuwe product "TOM" nog niet?',
        discoverTom: 'Ontdek TOM',
        reportedBy: 'Gerapporteerd door',
        amount: 'Aantal',
        makeReport: 'Maak een verslag',
        relevantPictures: 'Relevante beelden',
        allPictures: "Alle foto's"
    },
    mobileAppScreen: {
        title: 'We optimaliseren momenteel onze Web App voor mobiele apparaten.',
        subtitle:
            'Voor de beste gebruikerservaring kunt u onze App downloaden in de App Store of Google Play Store.'
    },
    addressForm: {
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        company: 'Bedrijf',
        streetAndNumber: 'Straat & Huisnummer',
        zip: 'Postcode',
        city: 'Stad',
        country: 'Land',
        note: 'Opmerking',
        companyNameRequireValidationMessage: 'Bedrijfsnaam is vereist',
        companyNameMinLengthValidationMessage: 'Bedrijfsnaam is te kort',
        companyNameMaxLengthValidationMessage: 'Bedrijfsnaam is te lang',
        companyIsValidValidationMessage: 'Ongeldige bedrijfsnaam',
        nameRequireValidationMessage: 'Voornaam is vereist',
        nameMinLengthValidationMessage: 'Voornaam is te kort',
        nameMaxLengthValidationMessage: 'Voornaam is te lang',
        nameIsValidValidationMessage: 'Ongeldige voornaam',
        lastNameRequireValidationMessage: 'Achternaam is vereist',
        lastNameMinLengthValidationMessage: 'Achternaam is te kort',
        lastNameMaxLengthValidationMessage: 'Achternaam is te lang',
        lastNameIsValidValidationMessage: 'Ongeldige achternaam',
        addressRequireValidationMessage: 'Straat & Huisnummer zijn vereist',
        addressIsValidValidationMessage:
            'Ongeldig formaat voor Straat & Huisnummer',
        zipCodeRequireValidationMessage: 'Postcode is vereist',
        zipCodeIsValidValidationMessage: 'Ongeldige postcode',
        cityRequireValidationMessage: 'Stad is vereist',
        cityIsValidValidationMessage: 'Ongeldige stadsnaam',
        countryRequireValidationMessage: 'Land is vereist',
        countryIsValidValidationMessage: 'Ongeldige landnaam'
    },
    billing: {
        billing: 'Facturering',
        externalUsersCreationNotice:
            'Nieuwe externe gebruikers die na 01.01.2025 worden aangemaakt, worden maandelijks elk voor €2,50 excl. BTW in rekening gebracht. U vindt het overzicht van uw maandelijkse abonnementen in het factureringsdashboard.',
        escalationLevelsCreationNotice:
            'Nieuwe e-mailadressen die na 01.01.2025 worden gebruikt voor escalatieniveaus worden maandelijks elk voor €2,50 excl. BTW in rekening gebracht. U vindt het overzicht van uw maandelijkse abonnementen in het factureringsdashboard.',
        billingDashboard: 'Factureringsdashboard',
        lastHeartbeat: 'Laatste heartbeat',
        removedAt: 'Verwijderd op',
        externalUsers: 'Externe gebruikers',
        amount: 'Bedrag',
        apiDevices: 'Apparaten-API',
        monetisation: 'Monetarisatie',
        itCanUpToAMinute: 'Het kan tot een minuut duren',
        currentMonth: 'Huidige maand'
    }
}

export default nl
